import moment from "moment";

export function isMobile() {
  if (window.innerWidth < 992) {
    return true;
  } else {
    return false;
  }
}

export function getEdad(fechaNacimiento) {
  if (!fechaNacimiento) {
    return "";
  }

  const fecha = moment(fechaNacimiento, ["DD/MM/YYYY", "YYYY-MM-DD"], true);

  if (!fecha.isValid()) {
    return "";
  }

  const hoy = moment();

  const años = hoy.diff(fecha, "years");

  if (años >= 1) {
    return `${años} año${años !== 1 ? "s" : ""}`;
  }

  const meses = hoy.diff(fecha, "months");

  if (meses >= 1) {
    return `${meses} mes${meses !== 1 ? "es" : ""}`;
  }

  const dias = hoy.diff(fecha, "days");

  return `${dias} día${dias !== 1 ? "s" : ""}`;
}

/**
 * Predicado compartido de visibilidad de la opción de menú "Finalizar Atención".
 *
 * Retorna verdadero si y solo si:
 *  - la institución tiene el tracking habilitado (trackingHabilitado === true), y
 *  - el turno está en Estado Atendido (estadoTurno === 3), y
 *  - el menú está en Modo Normal, es decir no está en modo copiar/reprogramar (copiar === 0), y
 *  - el turno aún no tiene registrada su fecha de fin de atención (!fechaFinAtencion).
 *
 * Función pura: no depende de estado externo ni produce efectos secundarios.
 *
 * @param {boolean} trackingHabilitado Bandera de la institución (usuario.institucion.trackingHabilitado).
 * @param {number} estadoTurno Estado del turno (3 === Atendido).
 * @param {number} copiar Bandera de modo copiar/reprogramar de la grilla (0 === Modo Normal).
 * @param {*} fechaFinAtencion Fecha de fin de atención del turno (nula/vacía si aún no finalizó).
 * @returns {boolean} true si la opción "Finalizar Atención" debe mostrarse.
 *
 * Requirements: 4.1, 4.2, 4.3, 4.4, 4.5
 */
export function puedeFinalizarAtencion(
  trackingHabilitado,
  estadoTurno,
  copiar,
  fechaFinAtencion
) {
  return (
    trackingHabilitado === true &&
    estadoTurno === 3 &&
    copiar === 0 &&
    !fechaFinAtencion
  );
}
